export default __webpack_public_path__ + "static/media/icono-kpi.a84c52cf.png";